import { useMemo } from 'react';

import type { TypeSelectOption } from '@thefarmersfront/kitchen';

import { Table, TableBottomField, TableTopField } from '~/components/common';

import { getDeliveryAgencyCollectingRequestCandidatesColumnDefs } from '~/utils/delivery-agency/table';

import { DELIVERY_AGENCY_TRACKING_PAGE_SIZE } from '~/constants/delivery-agency';

import type { TypePagination } from '~/types/common.types';
import type { CollectingOutboundListItem } from '~/types/delivery-agency.types';

import styles from './CollectingRequestCandidateTable.module.scss';

const getRowId = (row: CollectingOutboundListItem) => row.outboundCode;

const CollectingRequestCandidateTable = ({
  data,
  selectedOutboundCode,
  pagination,
  onChangePageLimit,
  onChangePage,
  onChangeRowSelection,
}: {
  data: CollectingOutboundListItem[] | null;
  selectedOutboundCode: string | null;
  pagination: TypePagination;
  onChangePageLimit: (value: TypeSelectOption<number>) => void;
  onChangePage: (value: number) => void;
  onChangeRowSelection: (rows: CollectingOutboundListItem[]) => void;
}) => {
  const { columnDefs } = useMemo(
    () =>
      getDeliveryAgencyCollectingRequestCandidatesColumnDefs({
        currentPage: pagination.currentPage - 1,
        pageSize: pagination.pageSize,
      }),
    [pagination.currentPage, pagination.pageSize]
  );
  const selectedRowIds = useMemo(() => (selectedOutboundCode ? [selectedOutboundCode] : []), [selectedOutboundCode]);

  return (
    <div className={styles['table-container']}>
      <TableTopField dataTotalCount={pagination.totalCount} />

      <div className={styles['table-wrapper']}>
        <Table
          data={data}
          columns={columnDefs}
          rowStatusType={data === null ? 'INIT' : 'COLLECTING_CANDIDATE_EMPTY'}
          getRowId={getRowId}
          selection={{ mode: 'single', selectedRowIds, onChange: onChangeRowSelection }}
        />
      </div>

      <TableBottomField
        pageSizeOptions={Object.values(DELIVERY_AGENCY_TRACKING_PAGE_SIZE)}
        currentPage={pagination.currentPage - 1}
        totalCount={pagination.totalCount}
        pageSize={pagination.pageSize}
        onChangePageLimit={onChangePageLimit}
        onClickPage={(page) => onChangePage(page + 1)}
      />
    </div>
  );
};

export default CollectingRequestCandidateTable;
